/**
 * Hook para obtener caducidad de puntos.
 */
import type { PointCaducityDto } from "common/models";
import { useQuery } from "react-query";
import { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { Queries } from "ui/query/queries";
import { config } from "common/config";
import { tokenApi } from "../api/tokenApi";

export function useGetPointCaducity<TData = PointCaducityDto>(
    options: UseCustomQueryOptions<PointCaducityDto, unknown, TData, string[]> = {}
) {
    const organizationAddress = config.organization.address;
    return useQuery(
        [Queries.POINT_CADUCITY, organizationAddress],
        () => tokenApi.getPointCaducity(organizationAddress),
        { ...options }
    );
}
